<!-- eslint-disable vue/multi-word-component-names -->
<template>
   <div class="selectfield--selected-tag">
      <span>{{ name }}</span>
      <CloseIcon v-if="showCloseIcon" @click="onClick($event)" />
   </div>
</template>

<script lang="ts" setup>
import CloseIcon from "../../../../assets/icons/close.svg?component"

defineProps({
   name: {
      type: String,
      default: ""
   },
   showCloseIcon: {
      type: Boolean,
      default: true
   }
})

const emits = defineEmits<{
   (e: "closeclick"): void
}>()

const onClick = (ev: Event) => {
   ev.stopPropagation()

   emits("closeclick")
}
</script>
